// 면장 수신함 — 자동수신된 면장의 검수 큐 (승인/반려/수동첨부)
// 설계: docs/analysis/myunjang-mail-auto-ingest-design-2026-07-23.md (Phase 5)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var MATCH_LABEL = {
  exact: { t: '정확일치', c: '#16a34a', b: '#dcfce7' },
  partial: { t: '뒷6자리', c: '#d97706', b: '#fef3c7' },
  mixed: { t: '혼합', c: '#d97706', b: '#fef3c7' },
  not_in_inventory: { t: '재고없음', c: '#dc2626', b: '#fee2e2' },
  none: { t: '매칭실패', c: '#dc2626', b: '#fee2e2' },
};

function MailIngestQueue({ showToast, user }) {
  var [items, setItems] = useState([]);
  var [statusFilter, setStatusFilter] = useState('pending_review');
  var [loading, setLoading] = useState(true);
  var [carNoInput, setCarNoInput] = useState({}); // {queueId: '차량번호'}
  var [busy, setBusy] = useState(0);

  var load = function () {
    setLoading(true);
    authFetch(API + '/myunjang-queue?status=' + statusFilter).then(function (r) { return r.json(); }).then(function (d) {
      setItems((d && d.items) || []);
      setLoading(false);
    }).catch(function () { setLoading(false); });
  };
  useEffect(function () { load(); }, [statusFilter]); // eslint-disable-line

  var approve = function (it, carNos) {
    setBusy(it.id);
    var body = carNos && carNos.length ? { carNos: carNos } : {}; // carIds 없으면 후보(matched_car_ids) 사용
    authFetch(API + '/myunjang-queue/' + it.id + '/approve', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
    }).then(function (r) { return r.json(); }).then(function (d) {
      setBusy(0);
      if (d.success) { showToast('첨부 완료 (' + (d.cars ? d.cars.length : 0) + '대)'); load(); }
      else showToast(d.error || '승인 실패', 'err');
    }).catch(function () { setBusy(0); showToast('서버 오류', 'err'); });
  };
  var reject = function (it) {
    setBusy(it.id);
    authFetch(API + '/myunjang-queue/' + it.id + '/reject', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
      .then(function (r) { return r.json(); }).then(function (d) {
        setBusy(0);
        if (d.success) { showToast('반려 처리'); load(); } else showToast(d.error || '반려 실패', 'err');
      }).catch(function () { setBusy(0); showToast('서버 오류', 'err'); });
  };

  var card = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 16, marginBottom: 12 };
  var pill = function (m) { var l = MATCH_LABEL[m] || MATCH_LABEL.none; return <span style={{ background: l.b, color: l.c, borderRadius: 8, padding: '2px 8px', fontSize: 11, fontWeight: 700 }}>{l.t}</span>; };
  var kv = { fontSize: 12, color: '#475569', marginRight: 14 };

  return (<div style={{ padding: 20, maxWidth: 900 }}>
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
      <div>
        <div style={{ fontSize: 18, fontWeight: 800, color: '#1B3A5C' }}>{'면장 수신함'}</div>
        <div style={{ fontSize: 12, color: '#64748b' }}>{'관세사 메일로 자동 수신된 수출신고필증 검수'}</div>
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        {[['pending_review', '검수 대기'], ['all', '전체']].map(function (o) {
          return <button key={o[0]} onClick={function () { setStatusFilter(o[0]); }} style={{ padding: '6px 14px', borderRadius: 8, border: statusFilter === o[0] ? '2px solid #1B3A5C' : '1px solid #d0d5dd', background: statusFilter === o[0] ? '#f0f4f8' : '#fff', color: statusFilter === o[0] ? '#1B3A5C' : '#475569', fontWeight: 700, fontSize: 12, cursor: 'pointer' }}>{o[1]}</button>;
        })}
        <button onClick={load} style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #d0d5dd', background: '#fff', fontSize: 12, cursor: 'pointer' }}>{'새로고침'}</button>
      </div>
    </div>

    {loading && <div style={{ color: '#94a3b8', fontSize: 13, padding: 20 }}>{'불러오는 중...'}</div>}
    {!loading && items.length === 0 && <div style={{ color: '#94a3b8', fontSize: 13, padding: 40, textAlign: 'center', background: '#fff', borderRadius: 12, border: '1px dashed #e5e7eb' }}>{'검수할 항목이 없습니다.'}</div>}

    {items.map(function (it) {
      var done = it.status === 'auto_applied' || it.status === 'applied';
      var rejected = it.status === 'rejected';
      var hasCandidates = it.candidates && it.candidates.length > 0;
      return (<div key={it.id} style={{ ...card, opacity: (done || rejected) ? 0.7 : 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          {pill(it.match_type)}
          {done && <span style={{ background: '#dcfce7', color: '#16a34a', borderRadius: 8, padding: '2px 8px', fontSize: 11, fontWeight: 700 }}>{it.status === 'auto_applied' ? '자동첨부됨' : '첨부완료'}</span>}
          {rejected && <span style={{ background: '#f1f5f9', color: '#64748b', borderRadius: 8, padding: '2px 8px', fontSize: 11, fontWeight: 700 }}>{'반려됨'}</span>}
          <span style={{ fontSize: 13, fontWeight: 700, color: '#222' }}>{it.subject || '(제목 없음)'}</span>
        </div>
        <div style={{ marginBottom: 8 }}>
          <span style={kv}>{'발신: '}{it.from_addr || '-'}</span>
          <span style={kv}>{'신고번호: '}<strong>{it.export_dec_no || '-'}</strong></span>
          <span style={kv}>{'신고일: '}{it.export_date || '-'}</span>
          {it.exporter_name && <span style={kv}>{'수출자: '}{it.exporter_name}</span>}
        </div>
        <div style={{ fontSize: 12, color: '#475569', marginBottom: 8 }}>
          {'차대번호: '}{(it.extracted_vins || []).length ? it.extracted_vins.join(', ') : '-'}
        </div>
        {hasCandidates && <div style={{ fontSize: 12, color: '#334155', marginBottom: 8 }}>
          {'후보 차량: '}{it.candidates.map(function (c) { return c.carNo + ' (' + (c.vin || '').slice(-6) + ')'; }).join(', ')}
        </div>}

        {!done && !rejected && <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 10, flexWrap: 'wrap' }}>
          {hasCandidates && <button disabled={busy === it.id} onClick={function () { approve(it, null); }} style={{ padding: '8px 16px', borderRadius: 6, border: 'none', background: '#16a34a', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'후보 차량에 첨부'}</button>}
          <input value={carNoInput[it.id] || ''} onChange={function (e) { var m = Object.assign({}, carNoInput); m[it.id] = e.target.value; setCarNoInput(m); }} placeholder="차량번호 직접 입력 (예: 12가3456)" style={{ padding: '7px 10px', border: '1px solid #d0d5dd', borderRadius: 6, fontSize: 12, width: 200 }} />
          <button disabled={busy === it.id} onClick={function () { var v = (carNoInput[it.id] || '').trim(); if (!v) { showToast('차량번호를 입력하세요', 'err'); return; } approve(it, [v]); }} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #1B3A5C', background: '#fff', color: '#1B3A5C', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'이 차량에 첨부'}</button>
          <button disabled={busy === it.id} onClick={function () { reject(it); }} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #fca5a5', background: '#fff', color: '#dc2626', fontSize: 12, fontWeight: 700, cursor: 'pointer', marginLeft: 'auto' }}>{'반려'}</button>
        </div>}
      </div>);
    })}
  </div>);
}

export default MailIngestQueue;
